import classNames from 'classnames';
import { useFormContext, useWatch } from 'react-hook-form';

import FieldError from 'components/form/FieldError';

import { ICheckboxProps } from './interfaces';

export const Checkbox = ({
  name,
  label,
  additionalClassName,
}: ICheckboxProps): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const currentValue = useWatch({
    name,
  });

  const className = classNames('checkbox', additionalClassName, {
    'checkbox--error': !!errors?.[name],
  });

  const inputClassName = classNames('checkbox__input', {
    'checkbox__input--checked': !currentValue,
  });

  return (
    <div className={className}>
      <label className="checkbox__input-container">
        <input
          id={name}
          type="checkbox"
          className={inputClassName}
          {...register(name)}
        />
        <div className="checkbox__check-mark"></div>
      </label>
      <label className={'checkbox__label'}>{label}</label>
      <FieldError
        name={name}
        errors={errors}
        additionalClassName={'contact-form__error--checkbox'}
      />
    </div>
  );
};
